<template>
  <div class="video-modal" v-if="isOpen" @click="handleBackgroundClick">
    <div class="video-modal__overlay"></div>
    <div class="video-modal__content" @click.stop>
      <button class="video-modal__close" @click="closeModal" aria-label="닫기">
        ×
      </button>
      <div class="video-modal__player">
        <video
          v-if="video && video.playType === 'video'"
          class="video-modal__video"
          :src="video.embedUrl"
          controls
          autoplay
          playsinline
        ></video>
        <iframe
          v-else-if="video && video.embedUrl"
          :src="video.embedUrl"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    video: {
      type: Object,
      default: null
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    handleBackgroundClick() {
      this.closeModal();
    }
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  }
};
</script>

<style scoped lang="scss">
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-modal__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}

.video-modal__content {
  position: relative;
  width: 90%;
  max-width: 1200px;
  z-index: 1;
}

.video-modal__close {
  position: absolute;
  top: -40px;
  right: 0;
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  color: white;
  font-size: 40px;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }
}

.video-modal__player {
  position: relative;
  padding-top: 56.25%;
  background: #000;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .video-modal__video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #000;
  }
}
</style>